/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-restricted-globals */
/* eslint-disable class-methods-use-this */
var ezdia;
(function (ezdia) {
    var ez = $.ezdia;
    var TYPE = 'steps';
    var ID_PREFIX = 'ez-js-steps--';
    var CANCEL_BTN_OBJ = {
        label: 'Cancel',
        name: 'canel',
        type: 'cancel'
    };
    var BACK_BTN_OBJ = {
        label: 'Back',
        name: 'back',
        type: 'back'
    };
    var DEFAULT = {
        stepsBlockId: ID_PREFIX + "block",
        stepsBodyBlockId: ID_PREFIX + "body-block",
        stepTemplate: ezdia.templates.steps.stepWrapper,
        stepReviewTemplate: ezdia.templates.steps.stepReview,
        stepBriefTemplate: ezdia.templates.steps.stepBrief,
        currentIndex: 0,
        currentName: null
    };
    var countDown = null;
    var widgets;
    (function (widgets) {
        var Steps = /** @class */ (function () {
            function Steps(options) {
                this.init(options);
            }
            Object.defineProperty(Steps.prototype, "Defaults", {
                // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                get: function () {
                    return DEFAULT;
                },
                enumerable: false,
                configurable: true
            });
            Steps.prototype.getCurrentIndex = function () {
                var _this = this;
                var currentIndex = this.options.currentIndex;
                if (this.options.currentName) {
                    // eslint-disable-next-line consistent-return
                    $.each(this.options.stepsObj.steps, function (i, obj) {
                        if (_this.options.currentName === obj.name) {
                            currentIndex = i;
                            return false;
                        }
                    });
                }
                return currentIndex;
            };
            Steps.prototype.getCurrentStepObject = function (index) {
                var currentIndex = +index === 0 || index ? +index : this.currentIndex;
                return this.options.stepsObj.steps[currentIndex];
            };
            Steps.prototype.init = function (options) {
                this.stepTime = {};
                this.reviewData = [];
                this.cache = {
                    urlParamsData: [],
                    dom: {}
                };
                this.options = this.getOptions(options);
                this.currentIndex = this.getCurrentIndex();
                this.cache.dom = {
                    stepsWrapper: $("#" + this.options.stepsBlockId),
                    stepsBodyWrapper: $("#" + this.options.stepsBodyBlockId)
                };
            };
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            Steps.prototype.render = function (props) {
                this.createSteps();
                this.createPageView();
                this.events();
            };
            Steps.prototype.getFieldMarkup = function (options) {
                var markup = ez.inputs.getMarkup(options);
                var retVal = markup ? markup.prop('outerHTML') : '';
                return retVal;
            };
            Steps.prototype.getFormData = function (name) {
                var dataArray = this.cache.dom[name].form.serializeArray();
                var urlParamData = [];
                dataArray.push({
                    name: 'totalTime',
                    value: this.getStepTotalTime(name)
                }, {
                    name: 'autoSubmit',
                    value: this.autoSubmit
                });
                urlParamData = this.getPostParamData();
                return dataArray.concat(urlParamData);
            };
            Steps.prototype.geturl = function (section) {
                var _this = this;
                var url = section.url;
                var urlParams = '';
                if (this.currentIndex && section.urlParams) {
                    $.each(section.urlParams, function (i, param) {
                        urlParams += "&" + param.key + "=" + _this.geturlParamValue(param.name);
                    });
                    if (urlParams) {
                        urlParams = urlParams.replace(/#/gi, '%23');
                        url = !url.includes('?') ? url + "?" : url;
                        url += urlParams;
                    }
                }
                return url;
            };
            Steps.prototype.getPostUrl = function (stepsObj) {
                var url = '';
                // eslint-disable-next-line consistent-return
                $.each(stepsObj.actions, function (i, btn) {
                    if (btn.type === 'submit' ||
                        btn.type === 'save' ||
                        btn.type === 'next') {
                        url = btn.url;
                        return false;
                    }
                });
                return url;
            };
            // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
            Steps.prototype.geturlParamValue = function (name, index) {
                var _a;
                var value = '';
                var data = [];
                var newIndex = 0;
                if (index !== 0 && !index) {
                    newIndex = this.currentIndex - 1;
                }
                if (name.includes('.')) {
                    var arr = name.split('.');
                    newIndex = +arr[0];
                    // eslint-disable-next-line no-param-reassign
                    _a = __read(arr, 2), name = _a[1];
                }
                data = this.cache.urlParamsData[newIndex] || [];
                // eslint-disable-next-line consistent-return
                $.each(data, function (i, obj) {
                    if (obj.name === name) {
                        value = obj.value;
                        return false;
                    }
                });
                return value;
            };
            Steps.prototype.saveSuccess = function (res, button, event, data) {
                var msgobj = {};
                var stepName = this.getCurrentStepObject().name;
                if (res.msg_code === 400) {
                    var frm = this.cache.dom[stepName].form;
                    ez.validate.highlightServerErrors(frm, res.msg);
                }
                else if (res.success) {
                    this.next(button, event, data);
                }
                else {
                    msgobj = {
                        error: true,
                        autohide: false
                    };
                    msgobj.message = res.msg;
                    ez.showSuccessError(msgobj);
                }
            };
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            Steps.prototype.success = function (pageType, res) {
                //
            };
            Steps.prototype.createSteps = function () {
                var stepsMarkup = this.getStepsMarkup();
                this.cache.dom.stepsWrapper.html(stepsMarkup);
            };
            Steps.prototype.getOptions = function (options) {
                return __assign(__assign({}, DEFAULT), options);
            };
            Steps.prototype.getStepsMarkup = function () {
                var template = ezdia.templates.steps.mainTemplate;
                return template({
                    steps: this.options.stepsObj.steps,
                    index: this.currentIndex
                });
            };
            Steps.prototype.createPageView = function () {
                var currentStepObj = this.getCurrentStepObject();
                var sections = currentStepObj.page_sections || [];
                var isReviewSection = currentStepObj.page_type === 'review';
                var isError = false;
                if (!sections.length && !isReviewSection) {
                    return;
                }
                if (isReviewSection) {
                    currentStepObj.classes = currentStepObj.classes + " ezdia-step-review";
                }
                this.getStepWrapperMarkup(currentStepObj);
                if (isReviewSection) {
                    this.createReview(currentStepObj);
                }
                else {
                    isError = this.createSectionsMarkup();
                }
                if (!isError) {
                    this.cache.dom[currentStepObj.name].wrapper.addClass('success');
                }
                this.setStartTime();
                if (this.isTimer()) {
                    this.timer();
                }
            };
            Steps.prototype.createSectionsMarkup = function () {
                var _this = this;
                var currentStepObj = this.getCurrentStepObject();
                var isError = false;
                // eslint-disable-next-line consistent-return
                $.each(currentStepObj.page_sections, function (i, section) {
                    var formattedUrl = _this.geturl(section);
                    var sectionWrapperMarkup = null;
                    var content = '';
                    var data = null;
                    if (section.type === 'message') {
                        data = section.message;
                    }
                    else if (section.formattedUrl &&
                        section.formattedUrl === formattedUrl) {
                        return true;
                    }
                    else {
                        section.formattedUrl = formattedUrl;
                        data = _this.getFields(formattedUrl);
                        section.urlData = data;
                    }
                    sectionWrapperMarkup = _this.getSectionWrapperMarkup(section);
                    if (!data) {
                        isError = true;
                        _this.errors(data, 'section');
                        return false;
                    }
                    switch (section.type) {
                        case 'message':
                            content = _this.createMessageView(section);
                            break;
                        case 'grid':
                            content = _this.createGridView(section);
                            break;
                        case 'quick_actions':
                            content = _this.createQuickActionsView(section);
                            break;
                        case 'card':
                            content = _this.createCardView(section);
                            break;
                        case 'form':
                            currentStepObj.fields = section.urlData.colModel;
                            currentStepObj.totalQuestions = section.urlData.totalQuestions;
                            content = _this.createFormView(section);
                            break;
                        case 'creativebrief':
                            content = _this.createCreativebrief(section);
                            break;
                        default:
                            break;
                    }
                    if (content) {
                        sectionWrapperMarkup.html(content);
                    }
                });
                return isError;
            };
            Steps.prototype.createMessageView = function (section) {
                return "<div class=\"ez-callout ez-callout-warning\">" + section.message + "</div>";
            };
            Steps.prototype.createGridView = function (section) {
                return "<div class=\"ez-callout ez-callout-warning\">" + section.message + "</div>";
            };
            Steps.prototype.createQuickActionsView = function (section) {
                return "<div class=\"ez-callout ez-callout-warning\">" + section.message + "</div>";
            };
            Steps.prototype.createCardView = function (section) {
                return "<div class=\"ez-callout ez-callout-warning\">" + section.message + "</div>";
            };
            Steps.prototype.createFormView = function (section) {
                var _this = this;
                var currentStepObj = this.getCurrentStepObject();
                var stepName = currentStepObj.name;
                var fields = section.urlData.colModel || {};
                var frmId = ID_PREFIX + stepName;
                var context = '';
                $.each(fields, function (i, col) {
                    var isCustomeUI = false;
                    col.config = ez.getFieldsConfig(col) || {};
                    col.labelInfo = col.label;
                    col.label = "Question " + (+String(i) + 1);
                    col.id = ID_PREFIX + stepName + "--" + col.name;
                    if (col.edittype === 'radio') {
                        isCustomeUI = true;
                    }
                    context += _this.getFieldMarkup({
                        column: col,
                        index: i,
                        value: col.defaultValue || col.config.value || '',
                        isCustomeUI: isCustomeUI
                    });
                });
                var form = "<form\n          id=\"" + frmId + "\"\n          name=\"" + name + "\"\n          class=\"form-horizontal ezdia-form desk ezdia-steps-form " + (section.classes || '') + "\">\n          " + context + "\n          <div class=\"clearfix\"></div><div data-container=\"error\" style=\"display: none\"></div>\n        </form>";
                setTimeout(function () {
                    _this.cache.dom[stepName].form = $("#" + ID_PREFIX + stepName);
                    $.ezdia.validate.all(fields, frmId);
                    $.ezdia.widgets.renderAll(fields, stepName);
                }, 0);
                return form;
            };
            Steps.prototype.createCreativebrief = function (section) {
                var briefObj = {
                    Brief: {}
                };
                var briefMarkup = {};
                if (section.urlData) {
                    var bodyId = ID_PREFIX + "body--" + (section.name || 'brief');
                    var template = this.options.stepBriefTemplate;
                    var brief = section.urlData.brief || [];
                    var briefname = brief[0] ? brief[0].briefname : '';
                    $.ezdia.config.creativeBriefCol = section.urlData.colModel;
                    briefObj = {
                        _value: { Brief: brief }
                    };
                    $.ezdia.creativeBrief.init(briefObj, {
                        name: section.name,
                        key: section.name,
                        value: briefname,
                        preview: true
                    });
                    briefMarkup = $.ezdia.creativeBrief.create(briefObj);
                    briefMarkup = template({
                        briefname: briefname,
                        href: "#" + bodyId,
                        bodyId: bodyId,
                        content: briefMarkup
                    });
                }
                return briefMarkup;
            };
            Steps.prototype.createReview = function (currentStepObj) {
                var _this = this;
                var sections = currentStepObj.page_sections || [];
                var isReviewBlocks = sections.length;
                // eslint-disable-next-line no-param-reassign
                currentStepObj = currentStepObj || this.getCurrentStepObject();
                if (!this.reviewData.length) {
                    return;
                }
                // eslint-disable-next-line consistent-return
                $.each(this.reviewData, function (index, reviewData) {
                    var step = null;
                    if (!reviewData) {
                        return true;
                    }
                    step = _this.getCurrentStepObject(index);
                    if (!isReviewBlocks ||
                        (isReviewBlocks && sections.includes(step.name))) {
                        _this.getReviewSectionMarkup(step, index);
                    }
                });
            };
            Steps.prototype.getReviewSectionMarkup = function (stepObj, index) {
                var self = this;
                var sectionWrapperMarkup = this.getSectionWrapperMarkup({
                    type: stepObj.name
                });
                var template = this.options.stepReviewTemplate;
                var data = this.reviewData[index];
                var dataObj = this.serializeObject(data);
                var panelId = ID_PREFIX + "panel--" + stepObj.name;
                var bodyId = ID_PREFIX + "body--" + stepObj.name;
                var fields = [];
                $.each(stepObj.fields, function (i, obj) {
                    if (obj.config && obj.config.review) {
                        fields.push({
                            column: obj,
                            value: dataObj[obj.name],
                            index: i
                        });
                    }
                });
                var content = template({
                    label: stepObj.label,
                    panelId: panelId,
                    bodyId: bodyId,
                    href: "#" + bodyId,
                    fileds: fields,
                    index: index
                });
                sectionWrapperMarkup.append(content);
                $("#" + panelId)
                    .find('.panel-heading')
                    .find('[data-action]')
                    .on('click', function click(e) {
                    self.back(this, e, index);
                });
            };
            Steps.prototype.events = function () {
                var self = this;
                this.cache.dom.stepsBodyWrapper.on("click." + TYPE, '[data-step-action-btn]', function click(event) {
                    var btnType = $(this).data('stepActionBtn');
                    self.pauseTimer();
                    if (self[btnType]) {
                        self[btnType](this, event);
                    }
                });
            };
            Steps.prototype.isTimer = function () {
                var returnVal = false;
                var stepsObj = this.options.stepsObj;
                var stepIndex = stepsObj.timer_start_step_index;
                if (this.isGlobalTimer) {
                    returnVal = true;
                }
                else if (stepsObj.timer &&
                    (!stepIndex || stepIndex === this.currentIndex)) {
                    this.isGlobalTimer = true;
                    this.globalTime = stepsObj.timer;
                    returnVal = true;
                }
                else {
                    returnVal = this.getCurrentStepObject().timer || false;
                }
                return returnVal;
            };
            Steps.prototype.timer = function () {
                var _this = this;
                var stepObj = this.getCurrentStepObject();
                var stepName = stepObj.name;
                countDown = Object.create(ez.timer);
                countDown.init({
                    time: this.globalTime || stepObj.timer,
                    container: this.cache.dom[stepName].footer__center
                });
                countDown.start();
                this.isTimerActive = true;
                $(countDown)
                    .off('timer:done')
                    .on('timer:done', function () {
                    countDown.clear();
                    _this.autoSubmit = true;
                    _this.timerFinish();
                });
            };
            Steps.prototype.pauseTimer = function () {
                if (this.isTimerActive) {
                    countDown.pause();
                }
            };
            Steps.prototype.restartTimer = function () {
                if (this.isTimerActive) {
                    countDown.restart();
                }
            };
            Steps.prototype.suspendTimer = function () {
                if (this.isTimerActive) {
                    this.isTimerActive = false;
                    if (this.globalTime) {
                        this.globalTime = countDown.getRemaningTime();
                    }
                    countDown.clear();
                }
            };
            Steps.prototype.timerFinish = function () {
                var currentStepObj = this.getCurrentStepObject();
                var stepName = currentStepObj.name;
                var dom = this.cache.dom[stepName];
                var stepLen = this.options.stepsObj.steps.length - 1;
                dom.footer.hide();
                dom.body.hide();
                if (this.isGlobalTimer) {
                    this.isGlobalSubmitActive = true;
                    if (stepLen === this.currentIndex) {
                        this.triggerPrimaryAction(currentStepObj);
                    }
                    else {
                        this.triggerGlobalSubmit();
                    }
                }
                else {
                    this.triggerPrimaryAction(currentStepObj);
                }
            };
            Steps.prototype.triggerPrimaryAction = function (currentStepObj) {
                var stepName = currentStepObj.name;
                var actionType = this.getPrimaryAction(currentStepObj);
                if (!actionType) {
                    // eslint-disable-next-line no-console
                    console.error('Primary Actions is missing for ', currentStepObj.label);
                    return;
                }
                var btn = this.cache.dom[stepName].footer.find("[data-step-action-btn=" + actionType + "]");
                btn.trigger('click');
            };
            Steps.prototype.triggerGlobalSubmit = function () {
                var stepsArray = this.options.stepsObj.steps;
                var stepsLen = stepsArray.length;
                var currentStepObj = this.getCurrentStepObject();
                var stepName = currentStepObj.name;
                this.setReviewData(stepName);
                for (var i = this.currentIndex + 1; i < stepsLen; i++) {
                    this.currentIndex = i;
                    currentStepObj = stepsArray[i];
                    var actionType = this.getPrimaryAction(currentStepObj);
                    if (actionType === 'submit') {
                        this.submit();
                    }
                    else {
                        this.reviewData[i] = null;
                    }
                }
            };
            Steps.prototype.next = function (button, event, data) {
                var $button = $(button).button('loading');
                var stepName = this.getCurrentStepObject().name;
                var frm = this.cache.dom[stepName].form;
                if (data) {
                    //
                }
                else if (!this.autoSubmit && frm && !frm.valid()) {
                    $button.button('reset');
                    this.restartTimer();
                    return;
                }
                else {
                    // eslint-disable-next-line no-param-reassign
                    data = this.setReviewData(stepName);
                }
                this.suspendTimer();
                this.cache.urlParamsData[this.currentIndex] = data;
                this.hideStep(stepName);
                this.currentIndex += 1;
                this.createSteps();
                this.createPageView();
                $button.button('reset');
            };
            Steps.prototype.save = function (button, event) {
                var self = this;
                var $button = $(button).button('loading');
                var currentStepObj = this.getCurrentStepObject();
                var stepName = currentStepObj.name;
                var frm = this.cache.dom[stepName].form;
                if (!this.autoSubmit && frm && !frm.valid()) {
                    $button.button('reset');
                    this.restartTimer();
                    return;
                }
                this.suspendTimer();
                var data = this.getFormData(stepName);
                ajaxPost({
                    url: this.getPostUrl(currentStepObj),
                    data: data,
                    success: function (res) {
                        self.saveSuccess(res, button, event, data);
                        $button.button('reset');
                    },
                    error: function () {
                        ez.showSuccessError({
                            error: true,
                            message: 'Internal server error. Please try after sometime.',
                            autohide: false
                        });
                        $button.button('reset');
                    }
                });
            };
            Steps.prototype.submit = function (button) {
                var _this = this;
                var self = this;
                var $button = $(button || {}).button('loading');
                var reqCount = 0;
                var errorCount = 0;
                var currentStepObj = this.getCurrentStepObject();
                var pageType = currentStepObj.page_type;
                if (pageType !== 'review') {
                    var stepName = currentStepObj.name;
                    var frm = this.cache.dom[stepName].form;
                    if (!this.autoSubmit && frm && !frm.valid()) {
                        $button.button('reset');
                        this.restartTimer();
                        return;
                    }
                    this.setReviewData(stepName);
                }
                this.suspendTimer();
                if (!this.reviewData.length) {
                    $button.button('reset');
                    return;
                }
                // eslint-disable-next-line consistent-return
                $.each(this.reviewData, function (index, reviewData) {
                    var step = null;
                    if (!reviewData) {
                        return true;
                    }
                    step = _this.getCurrentStepObject(index);
                    ajaxPost({
                        url: _this.getPostUrl(step),
                        beforeSend: function () {
                            // eslint-disable-next-line no-plusplus
                            ++reqCount;
                        },
                        data: reviewData,
                        success: function (res) {
                            // eslint-disable-next-line no-plusplus
                            --reqCount;
                            if (!res.success) {
                                // eslint-disable-next-line no-plusplus
                                ++errorCount;
                                ez.showSuccessError({
                                    error: true,
                                    message: res.msg,
                                    autohide: false
                                });
                            }
                            if (!reqCount) {
                                $button.button('reset');
                                if (!errorCount) {
                                    self.success(pageType, res);
                                }
                            }
                        },
                        error: function () {
                            // eslint-disable-next-line no-plusplus
                            --reqCount;
                            // eslint-disable-next-line no-plusplus
                            ++errorCount;
                            if (!reqCount) {
                                $button.button('reset');
                            }
                        }
                    });
                });
            };
            Steps.prototype.back = function (button, event, index) {
                var stepName = this.getCurrentStepObject().name;
                this.getStepTotalTime(stepName);
                this.hideStep(stepName);
                if (index) {
                    this.currentIndex = index;
                }
                else {
                    this.currentIndex -= 1;
                }
                this.createSteps();
                stepName = this.getCurrentStepObject().name;
                if (this.cache.dom[stepName]) {
                    this.showStep(stepName);
                    this.setStartTime();
                }
                else {
                    // code for redirectUrl
                }
            };
            Steps.prototype.cancel = function () {
                window.location.href = this.options.stepsObj.scope || '/';
            };
            Steps.prototype.hideStep = function (name) {
                this.cache.dom[name].wrapper.hide();
            };
            Steps.prototype.showStep = function (name) {
                this.cache.dom[name].wrapper.show();
            };
            Steps.prototype.getStepWrapperMarkup = function (stepObj) {
                var idPrefix = 'ez-js-step-';
                var currentStepObj = this.getCurrentStepObject();
                var name = stepObj.name;
                var id = idPrefix + name;
                var wrap = $("#" + id);
                var idObj = {
                    id: id,
                    header: idPrefix + "header--" + name,
                    body: idPrefix + "body--" + name,
                    footer: idPrefix + "footer--" + name,
                    footer__left: idPrefix + "footer__left--" + name,
                    footer__center: idPrefix + "footer__center--" + name,
                    footer__right: idPrefix + "footer__right--" + name
                };
                var baseStepObj = {
                    ids: idObj
                };
                if (this.currentIndex && stepObj.back !== false) {
                    baseStepObj.back = BACK_BTN_OBJ;
                }
                if (this.options.stepsObj.scope) {
                    baseStepObj.cancel = CANCEL_BTN_OBJ;
                }
                if (!wrap.length) {
                    var template = this.options.stepTemplate;
                    var stepWrapObj = $.extend({}, baseStepObj, stepObj);
                    var content = template(stepWrapObj);
                    this.cache.dom.stepsBodyWrapper.append(content);
                    wrap = $("#" + id);
                    this.cache.dom[currentStepObj.name] = {
                        wrapper: wrap,
                        header: wrap.find("#" + idObj.header),
                        body: wrap.find("#" + idObj.body),
                        footer: wrap.find("#" + idObj.footer),
                        footer__left: wrap.find("#" + idObj.footer__left),
                        footer__center: wrap.find("#" + idObj.footer__center),
                        footer__right: wrap.find("#" + idObj.footer__right)
                    };
                }
                else {
                    wrap.show();
                }
                return this.cache.dom[currentStepObj.name];
            };
            Steps.prototype.getSectionWrapperMarkup = function (sectionObj) {
                var name = this.getCurrentStepObject().name;
                var id = ID_PREFIX + name + "--" + sectionObj.type;
                var wrap = $("#" + id);
                if (!wrap.length) {
                    var wrapper = $('<div>', {
                        id: id
                    });
                    this.cache.dom[name].body.append(wrapper);
                    wrap = $("#" + id);
                }
                return wrap.empty();
            };
            Steps.prototype.getStepTotalTime = function (stepName) {
                var time = this.stepTime[stepName];
                var total = new Date() - time.start;
                time.total += total;
                return time.total;
            };
            Steps.prototype.getPrimaryAction = function (stepsObj) {
                var type = '';
                // eslint-disable-next-line consistent-return
                $.each(stepsObj.actions, function (i, btn) {
                    if (btn.isPrimary) {
                        type = btn.type;
                        return false;
                    }
                });
                return type;
            };
            Steps.prototype.getPostParamData = function (stepsObj) {
                var _this = this;
                var data = [];
                // eslint-disable-next-line no-param-reassign
                stepsObj = stepsObj || this.getCurrentStepObject();
                // eslint-disable-next-line consistent-return
                $.each(stepsObj.actions, function (i, btn) {
                    var e_1, _a;
                    if (btn.type === 'submit' ||
                        btn.type === 'save' ||
                        btn.type === 'next') {
                        if (btn.urlParams) {
                            try {
                                for (var _b = __values(btn.urlParams), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    var _d = _c.value, key = _d.key, name_1 = _d.name;
                                    data.push({
                                        name: key,
                                        value: _this.geturlParamValue(name_1)
                                    });
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                        return false;
                    }
                });
                return data;
            };
            Steps.prototype.getFields = function (formattedUrl) {
                return ajaxGet({
                    url: formattedUrl,
                    async: false
                });
            };
            Steps.prototype.setReviewData = function (stepName) {
                if (stepName === void 0) { stepName = this.getCurrentStepObject().name; }
                var data = this.getFormData(stepName);
                this.reviewData[this.currentIndex] = data;
                return data;
            };
            Steps.prototype.setStartTime = function () {
                var stepName = this.getCurrentStepObject().name;
                if (!this.stepTime[stepName]) {
                    this.stepTime[stepName] = {};
                    this.stepTime[stepName].total = 0;
                }
                this.stepTime[stepName].start = new Date();
            };
            Steps.prototype.serializeObject = function (data) {
                var retunObj = {};
                if (data) {
                    $.each(data, function (i, obj) {
                        retunObj[obj.name] = obj.value;
                    });
                }
                return retunObj;
            };
            Steps.prototype.errors = function (obj, type) {
                var msg = obj && obj.msg
                    ? obj.msg
                    : 'Internal server error. Please try after some time.';
                if (type === 'section') {
                    var stepName = this.getCurrentStepObject().name;
                    var dom = this.cache.dom[stepName];
                    dom.body.html("<div class='alert alert-danger'>" + msg + "</div>");
                    dom.footer.remove();
                    dom.wrapper.addClass('error');
                }
            };
            return Steps;
        }());
        widgets.Steps = Steps;
        /*
         * PRIVATE  functions
         * * */
        /*
         * AJAX functions
         * * */
        var ajaxGet = function (ajaxObj) {
            var returnObj = null;
            var options = $.extend({
                type: 'GET',
                success: function (response) {
                    returnObj = response;
                },
                error: function (error) {
                    // eslint-disable-next-line no-console
                    console.log(error);
                }
            }, ajaxObj);
            $.ajax(options);
            return returnObj;
        };
        var ajaxPost = function (ajaxObj) {
            var returnObj = {};
            var options = $.extend({
                type: 'POST',
                dataType: 'json',
                success: function (response) {
                    returnObj = response;
                },
                error: function (error) {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    returnObj = error;
                }
            }, ajaxObj);
            $.ajax(options);
        };
        /*
         ** This $.ezdia is just for old code support
         ** DON'T USE THIS
         */
        $.ezdia.Steps = Steps;
    })(widgets = ezdia.widgets || (ezdia.widgets = {}));
})(ezdia || (ezdia = {}));
